export const CACHE_KEY_LAYER_SETTING = 'CACHE_KEY_LAYER_SETTING';
export const CACHE_KEY_ATRIBUTY = 'CACHE_KEY_ATRIBUTY';
export const CACHE_KEY_AKCE = 'CACHE_KEY_AKCE';
export const CACHE_KEY_LAYER_OPRAVNENI = 'CACHE_KEY_LAYER_OPRAVNENI';
export const CACHE_KEY_TOPICS_OWNED = 'CACHE_KEY_TOPICS_OWNED';
export const CACHE_KEY_TOPICS_OWNERS = 'CACHE_KEY_TOPICS_OWNERS';
export const CACHE_KEY_CATALOG_OPRAVNENI = 'CACHE_KEY_CATALOG_OPRAVNENI';
export const CACHE_KEY_TOPIC_OPRAVNENI = 'CACHE_KEY_TOPIC_OPRAVNENI';
export const CACHE_KEY_LAYER_TOPIC = 'CACHE_KEY_LAYER_TOPIC';
export const CACHE_KEY_PRINT_CONFIG = 'CACHE_KEY_PRINT_CONFIG';
export const CACHE_KEY_USER_LAYER_OPRAVNENI = 'CACHE_KEY_USER_LAYER_OPRAVNENI';
export const CACHE_KEY_FEATURE_DATA = 'CACHE_KEY_FEATURE_DATA';
export const CACHE_KEY_LAYER_ATTRIBUTES = 'CACHE_KEY_LAYER_ATTRIBUTES';
export const CACHE_KEY_VIEWPORT_FEATURE = 'CACHE_KEY_VIEWPORT_FEATURE';
export const CACHE_KEY_SEARCH_CARDS = 'CACHE_KEY_SEARCH_CARDS';
export const CACHE_KEY_LAYER_DATA_UPDATED = 'CACHE_KEY_LAYER_DATA_UPDATED';
export const CACHE_KEY_DETAIL_DTM = 'CACHE_KEY_DETAIL_DTM';
export const CACHE_KEY_SOUBORY_DTM = 'CACHE_KEY_SOUBORY_DTM';
